module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-login-view login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.wxlogin.title')))]), _vm._v(" "), _c('el-form', {
    ref: "login"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "login-container",
    attrs: {
      "id": "login_container"
    }
  }, [_c('spinner', {
    staticClass: "spinner"
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "left"
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.login.accountlogin')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.register')))]), _vm._v(" |\n        "), _c('router-link', {
    attrs: {
      "to": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.password')))])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de093570"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/session/wxlogin.view.vue
// module id = 951
// module chunks = 3